<template>
  <b-card>
    <div v-if="ready">
      <div class="clearfix">
        <div class="float-end">
          <div class="input-group input-group-sm">
            <select class="form-select form-select-sm" v-model="duration" @change="handleSelection">
              <option value="day" selected>{{ $t('pages.feedbacks.feedback_chart.daily') }}</option>
              <option value="week" selected>{{ $t('pages.feedbacks.feedback_chart.weekly') }}</option>
              <option value="month">{{ $t('pages.feedbacks.feedback_chart.monthly') }}</option>
            </select>
          </div>
        </div>
        <h4 class="card-title mb-4">
          {{  $t('pages.feedbacks.feedback_chart.title') }}
          <span class="text-muted">({{ $t('pages.feedbacks.feedback_chart.last_days', {days: 90}) }})</span>
        </h4>
      </div>
      <!-- Column Charts -->
      <apexchart
          class="apex-charts"
          height="350"
          type="area"
          dir="ltr"
          :series="series"
          :options="chartOptions"
      ></apexchart>
    </div>
    <chart-skeleton v-else :height="415"></chart-skeleton>
  </b-card>
</template>

<script>

import ChartSkeleton from "../../../components/Skeletons/ChartSkeleton";
import ReviewStatMixin from "../../../mixins/ReviewStatMixin";

export default {
  name: "FeedbackChart",
  components: {ChartSkeleton},
  props: ['data'],
  mixins: [ReviewStatMixin],
  data() {
    return {
      ready: false,
      series: [],
      chartOptions: {
        xaxis: {
          type: 'datetime',
          categories: [],
        },
        colors: ['#f46a6a', '#e83e8c', '#564ab1'],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: this.$t('pages.feedbacks.feedback_chart.counts'),
          align: 'left',
          style: {
            fontWeight: '500',
          },
        },
        markers: {
          size: 1,
          hover: {
            sizeOffset: 6
          }
        },
        grid: {
          borderColor: '#f1f1f1',
        },
        tooltip: {
          x: {
            formatter: val => {
              return this.tooltipFormatter(val)
            }
          }
        }
      },
    }
  },
  watch: {
    data() {
      this.calculateChartData()
    }
  },
  methods: {
    async handleSelection() {
      this.ready = false
      await this.calculateChartData()
      this.ready = true
    },
    async calculateChartData() {
      const chartData = await this.groupAndBuild(this.data, this.duration, this.duration)
      const oneStars = [], twoStars = [], threeStars = []
      const categories = []
      chartData.map(x => {
        categories.push(x[this.duration])

        oneStars.push(x.value[1])
        twoStars.push(x.value[2])
        threeStars.push(x.value[3])
      })

      this.series = [
        {name: this.$t('pages.feedbacks.feedback_chart.one_star'), data: oneStars},
        {name: this.$t('pages.feedbacks.feedback_chart.two_star'), data: twoStars},
        {name: this.$t('pages.feedbacks.feedback_chart.three_star'), data: threeStars},
      ]
      this.chartOptions.xaxis.categories = categories

      this.ready = true
    }
  },
}
</script>
